export function useAudioPlayHooks({audioPlayerRef,record},srcUrl=null){

  const playAudio=function () {
    audioPlayerRef.value?.play(); // 调用play()方法开始播放音频
  }
  const audioFilePath=ref(srcUrl||`${location.protocol}//${location.host}/`+unref(record).downloadApi);

  const stopAudio=function (){
    audioPlayerRef.value?.pause(); // 调用play()方法开始播放音频
  }

  const audioEnded=function (){
    if(unref(record).btnIcon){
      delete unref(record).btnIcon;
    }
  }
  return {
    audioEnded,
    stopAudio,
    playAudio,
    audioFilePath,
  }
}
